export default "__VITE_ASSET__BS442_PZ__"